const actionsBlacklist = [
  'WEBINAR:LIVE_PROFILING_DATA_ARRIVED',
  'WEBINAR:VOLUME_LEVELS_UPDATED',
  'WEBINARDEVICESELECTOR:PREVIEW_VOLUME_LEVELS_UPDATED',
  'PLAYBACK:VIDEO_PLAYBACK_METRICS_UPDATED',
]

export default actionsBlacklist
